let MoonfallQaEntry;

(function () {
    'use strict';

    let deckoutStart = null;

    async function startIfRequested({ href, startSoloGame } = {}) {
        let url;
        try {
            url = new URL(href || window.location.href);
        } catch (_) {
            return false;
        }
        if (url.searchParams.get('qa') !== 'deckout') return false;
        if (typeof startSoloGame !== 'function') {
            throw new Error('Deckout QA entry requires the solo-game client');
        }
        if (!deckoutStart) {
            deckoutStart = Promise.resolve(startSoloGame(null, { qaScenario: 'deckout' }))
                .then((started) => started === true || started?.ok === true);
        }
        return deckoutStart;
    }

    MoonfallQaEntry = { startIfRequested };
})();

export { MoonfallQaEntry };
